import React, { Component } from 'react';
import { Configurations } from '../../Utils/Configurations';
import ReactTable from 'react-table';
import moment from 'moment';
import update from 'immutability-helper';
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import './Foreigners.scss';
import axios from 'axios';




class ForeignersList extends Component {

    constructor(props) {
        super(props);
        this.toggleModalLink = this.toggleModalLink.bind(this);
        this.enviarLink = this.enviarLink.bind(this);
        this.carregaListaEstrangeiros = this.carregaListaEstrangeiros.bind(this);
        this.refreshTableEstrangeiros = this.refreshTableEstrangeiros.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);

        this.state = {

            openModalLink: false,
            listaEstrangeiro: [],
            limite: 10,
            pagina: 0,
            hasError: false,
            errorMessage: '',
            isLoadingEstrangeiros: false
        }

        this.Configurations = new Configurations();

        this.columns = [
            {
                Header: 'id',
                accessor: 'id',
                className: 'text-center',
                width: 50

            },
            {
                Header: 'Nome',
                accessor: 'nome',
                className: 'text-left',
                width: 200,
            },
            {
                Header: 'E-mail',
                accessor: 'email',
                className: 'text-center',
                width: 180,

            },
            {
                Header: 'Dt. criação',
                accessor: 'dtCriacao',
                className: 'text-center',
                width: 100,
                Cell: row => (row.value ? <span>{moment(row.value).format("DD/MM/YYYY")}</span> : <span>erro</span>)
            },
            {
                Header: 'Memb.SGI',
                accessor: 'membroSgi',
                className: 'text-center',
                width: 80,
                Cell: row => (<h6 className="m-0"><span className={`badge badge-${row.value ? 'success' : 'secondary badge-opacity'}`}>{row.value ? 'Sim' : 'Não'}</span></h6>),

            },
            {
                Header: '',
                accessor: 'id',
                className: 'text-center',
                width: 110,
                Cell: row => <button onClick={() => this.props.history.push(`/usuarios-especiais/detalhes/${row.value}`)} className="btn btn-sm btn-outline-info">Ver detalhes</button>
            },
            {
                Header: '',
                className: 'text-center',
                Cell: row => {
                    return (
                        <div className="row no-gutters">
                            <div className="col-12">
                                {row.original.loading ? (
                                    <div className="spinner-border spinner-border-sm text-primary align-items-center" role="status" />
                                ) : (
                                    <button onClick={() => this.enviarLink(row.original.id)} className="btn btn-sm btn-outline-success">Enviar link</button>
                                )}
                            </div>
                        </div>
                    )
                }
            }
        ]
    }

    componentWillMount() {
        this.carregaListaEstrangeiros();
    }

    carregaListaEstrangeiros(o) {
        let pagina, tamanhoListaEstrangeiro;
        if (o === undefined) {
            pagina = 0;
            tamanhoListaEstrangeiro = 10;
        }
        else if (!o.pageSize) {
            tamanhoListaEstrangeiro = this.state.limite;
        } else if (!(o.page + 1)) {
            pagina = this.state.pagina;
        } else {
            tamanhoListaEstrangeiro = o.pageSize;
            pagina = o.page;
            this.setState({
                pagina: pagina,
                limite: tamanhoListaEstrangeiro
            })
        }
        axios.get(this.Configurations.apiBasePath + `/estrangeiro?page=${pagina + 1}&limit=${tamanhoListaEstrangeiro}`).then(response => {
            this.setState({
                listaEstrangeiro: response.data.data,
                paginasEstrangeiros: response.data.paginacao.totalPaginas,
            });
        }).catch(this.handleError).finally(() => this.setState({
            isLoadingEstrangeiros: false
        }));
    }

    refreshTableEstrangeiros(o) {
        this.carregaListaEstrangeiros(o);
    }

    toggleModalLink() {
        this.setState({
            openModalLink: !this.state.openModalLink
        })
    }

    enviarLink(id) {
        const _index = this.state.listaEstrangeiro.findIndex(item => item.id === id);
        this.setState({ listaEstrangeiro: update(this.state.listaEstrangeiro, { [_index]: { loading: { $set: true } } }) })
        axios.post(this.Configurations.apiBasePath + `/token-estrangeiro/${id}`)
            .then(response =>
                this.setState({ openModalLink: true }))
            .catch(this.handleError)
            .finally(() => { this.setState({ listaEstrangeiro: update(this.state.listaEstrangeiro, { [_index]: { loading: { $set: false } } }) }) });
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.msg })
    }

    closeErrorModal() {
        this.setState({ hasError: false, errorMessage: "" })
    }

    render() {
        return (
            <div className="row foreigners-list">
                <div className="col-12">
                    <div className="row no-gutters align-items-center">
                        <div className="col-8 text-left mb-2">
                            <h2>Lista de estrangeiros cadastrados</h2>
                        </div>
                        <div className="col-4 text-right mb-2">
                            <button className="btn btn-outline-success" onClick={() => this.props.history.push('/usuarios-especiais/detalhes/novo-cadastro')}>Novo cadastro</button>
                        </div>
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body p-0 text-center">
                                    <ReactTable
                                        data={this.state.listaEstrangeiro}
                                        columns={this.columns}
                                        onFetchData={this.refreshTableEstrangeiros}
                                        defaultPageSize={10}
                                        pages={this.state.paginasEstrangeiros}
                                        page={this.state.pagina}
                                        manual
                                        pageSize={this.state.limite}
                                        loading={this.state.isLoadingEstrangeiros}
                                        className="tabela-estrangeiro"
                                        headerClassName="ebs-table-header"
                                        previousText='Anterior'
                                        nextText='Próximo'
                                        loadingText='Carregando...'
                                        noDataText='Nenhum item encontrado.'
                                        pageText='Página'
                                        ofText='de'
                                        rowsText='linhas'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal size="sm" isOpen={this.state.openModalLink} toggle={this.toggleModalLink}>
                    <ModalBody toggle={this.toggleModalLink}>
                        Link enviado com sucesso!
                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={this.toggleModalLink}>ok</Button>
                    </ModalFooter>
                </Modal>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
            </div>
        )

    }
}
export default ForeignersList;